(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
TAAR.SectionRegistry.register('404', function init(el) {
  TAAR.Animations.refresh(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var DISMISSED_KEY = 'taar_announcement_dismissed';

  TAAR.SectionRegistry.register('announcement-bar',

    function init(el) {
      var sectionId   = el.dataset.sectionId;
      var dismissBtn  = el.querySelector('[data-announce-dismiss]');

      /* Restore dismissed state */
      if (sessionStorage.getItem(DISMISSED_KEY + sectionId) === '1') {
        el.classList.add('is-dismissed');
        document.documentElement.style.setProperty('--announcement-height', '0px');
        return;
      }

      if (dismissBtn) {
        dismissBtn.addEventListener('click', function () {
          el.classList.add('is-dismissed');
          document.documentElement.style.setProperty('--announcement-height', '0px');
          try { sessionStorage.setItem(DISMISSED_KEY + sectionId, '1'); } catch (_) {}
          TAAR.EventBus.emit('announcement:dismissed');
        });
      }

    },

    function destroy(el) {
      /* SectionRegistry destroy — timers auto-clear when el is removed */
    }
  );
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
TAAR.SectionRegistry.register('article', function init(el) {
  if (window.TAAR && TAAR.Animations) TAAR.Animations.refresh(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
TAAR.SectionRegistry.register('blog', function init(el) {
  if (window.TAAR && TAAR.Animations) TAAR.Animations.refresh(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  'use strict';

  TAAR.SectionRegistry.register('cart-drawer',
    function init(el) {
      var releaseFocus = null;
      var isOpen = false;

      function openDrawer() {
        if (isOpen) return;
        isOpen = true;
        el.setAttribute('aria-hidden', 'false');
        TAAR.Util.lockScroll();
        releaseFocus = TAAR.Util.trapFocus(el);
      }

      function closeDrawer() {
        if (!isOpen) return;
        isOpen = false;
        el.setAttribute('aria-hidden', 'true');
        TAAR.Util.unlockScroll();
        if (releaseFocus) releaseFocus();
      }

      function esc(s) {
        return String(s || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function buildEmptyHTML() {
        return '<div class="cart-drawer__empty">'
          + '<div style="width:72px;margin:0 auto var(--space-5);color:var(--color-text-muted);opacity:.6;">'
          + '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="72" height="72">'
          + '<path d="M16 20h32l-4 24H20L16 20z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>'
          + '<path d="M24 20v-4a8 8 0 0 1 16 0v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>'
          + '</svg></div>'
          + '<p class="cart-drawer__empty-text">Your cart is empty.</p>'
          + '<button type="button" class="btn btn--primary btn--full" data-drawer-close>Continue shopping</button>'
          + '</div>';
      }

      function buildItemsHTML(cart) {
        var html = '<div class="cart-drawer__items">';
        cart.items.forEach(function (item) {
          var imgHTML = item.image
            ? '<div class="cart-drawer__item-image-wrap">'
              + '<img class="cart-drawer__item-image" src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" loading="lazy">'
              + '</div>'
            : '';
          var variantHTML = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<p class="cart-drawer__item-variant">' + esc(item.variant_title) + '</p>'
            : '';
          var priceHTML = (item.original_price !== item.final_price)
            ? '<s class="cart-drawer__item-price-original">' + TAAR.Util.formatMoney(item.original_price) + '</s>'
              + '<span class="cart-drawer__item-price-final">' + TAAR.Util.formatMoney(item.final_price) + '</span>'
            : '<span class="cart-drawer__item-price-final">' + TAAR.Util.formatMoney(item.final_price) + '</span>';

          html += '<div class="cart-drawer__item" data-key="' + esc(item.key) + '" data-product-id="' + item.product_id + '">'
            + '<div class="cart-drawer__item-image-wrapper">' + imgHTML + '</div>'
            + '<div class="cart-drawer__item-details">'
              + '<a href="' + esc(item.url) + '" class="cart-drawer__item-title">' + esc(item.product_title) + '</a>'
              + variantHTML
              + '<div class="cart-drawer__item-price">' + priceHTML + '</div>'
              + '<div class="cart-drawer__item-actions">'
                + '<button type="button" class="cart-drawer__remove btn btn--link" data-qty-remove>Remove</button>'
              + '</div>'
            + '</div>'
          + '</div>';
        });
        html += '</div>';
        return html;
      }
      function buildWhatsAppHTML(cart) {
  var message = 'Hi Taar! I have a question about the items in my cart:';

  cart.items.forEach(function (item) {
    var productURL = new URL(item.url, window.location.origin).href;

    message += '\n'
      + item.product_title
      + ' (Qty: ' + item.quantity + '): '
      + productURL;
  });

  var href = 'https://wa.me/19194541352?text='
    + encodeURIComponent(message);

  return '<a href="' + esc(href) + '"'
    + ' class="cart-drawer__whatsapp"'
    + ' target="_blank" rel="noopener noreferrer"'
    + ' aria-label="Ask about my cart on WhatsApp (opens in a new tab)">'
    + 'Ask about my cart on WhatsApp'
    + '</a>';
}
      
      function buildFooterHTML(cart) {
  var badgesTpl = el.querySelector('[data-payment-badges]');
  var badgesHTML = badgesTpl ? badgesTpl.innerHTML : '';

  return '<div class="cart-drawer__footer">'
    + '<div class="cart-drawer__subtotal">'
      + '<span class="cart-drawer__subtotal-label">Subtotal</span>'
      + '<span class="cart-drawer__subtotal-value">'
        + TAAR.Util.formatMoney(cart.total_price)
      + '</span>'
    + '</div>'
    + '<p class="cart-drawer__tax-note">'
      + 'Taxes and shipping calculated at checkout'
    + '</p>'
    + '<a href="/checkout" class="cart-drawer__checkout btn btn--primary btn--full">'
      + 'Proceed to Checkout'
    + '</a>'
    + buildWhatsAppHTML(cart)
    + (badgesHTML
      ? '<div class="cart-drawer__trust">' + badgesHTML + '</div>'
      : '')
    + '</div>';
}

      /* Rebuild drawer directly from /cart.js — no Section Rendering API dependency */
      function updateCartUI() {
        return TAAR.Cart.getState().then(function (cart) {
          var bodyEl  = el.querySelector('[data-cart-content]');
          var panel   = el.querySelector('.cart-drawer__panel');
          var oldFoot = el.querySelector('.cart-drawer__footer');
          if (!bodyEl) return;

          if (!cart.item_count) {
            bodyEl.innerHTML = buildEmptyHTML();
            if (oldFoot) oldFoot.remove();
          } else {
            bodyEl.innerHTML = buildItemsHTML(cart);
            var footerHTML = buildFooterHTML(cart);
            if (oldFoot) {
              oldFoot.outerHTML = footerHTML;
            } else if (panel) {
              var tmp = document.createElement('div');
              tmp.innerHTML = footerHTML;
              panel.appendChild(tmp.firstChild);
            }
          }

          var badge = document.querySelector('[data-cart-count]');
          if (badge) badge.textContent = cart.item_count || '';
        });
      }

      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-drawer-close]')) {
          closeDrawer();
          return;
        }

        var removeBtn = e.target.closest('[data-qty-remove]');
        if (removeBtn) {
          var item = removeBtn.closest('.cart-drawer__item');
          if (item) {
            TAAR.Cart.updateItem(item.getAttribute('data-key'), 0)
              .then(function () { return updateCartUI(); });
          }
        }
      });

      function fetchRecommendations() {
        var recContainer = el.querySelector('[data-cart-recommendations]');
        if (!recContainer) return;
        var firstItem = el.querySelector('.cart-drawer__item');
        if (!firstItem) return;
        var productId = firstItem.getAttribute('data-product-id');
        if (!productId) return;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'recommendations/products?section_id=cart-recommendations&product_id=' + productId + '&limit=2')
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var tmp = document.createElement('div');
            tmp.innerHTML = text;
            var recs = tmp.querySelector('.cart-recommendations');
            recContainer.innerHTML = (recs && recs.innerHTML.trim()) ? recs.outerHTML : '';
            if (recs) TAAR.Animations.refresh(recContainer);
          })
          .catch(function () {});
      }

      TAAR.EventBus.on('cart:opened', function () { openDrawer(); });
      TAAR.EventBus.on('cart:closed',  closeDrawer);
      TAAR.EventBus.on('cart:updated', function () { updateCartUI(); });
      TAAR.EventBus.on('cart:item-added', function () {
        updateCartUI().then(function () {
          openDrawer();
          setTimeout(fetchRecommendations, 600);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) closeDrawer();
      });
    }
  );
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  'use strict';

  TAAR.SectionRegistry.register('cart', function init(el) {
    TAAR.Animations.refresh(el);

    var cartItems = el.querySelector('[data-cart-items]');
    if (!cartItems) return; /* empty state — nothing interactive */

    var subtotalEl = el.querySelector('[data-cart-subtotal]');
    var countEl    = el.querySelector('.cart-page__count');

    /* Initialise each line item. Single-piece store: quantity is always 1, so
       the only action is remove. Remove must update the Shopify cart on the
       server (quantity 0), then animate the row out — not just hide it. */
    el.querySelectorAll('[data-cart-item]').forEach(function (item) {
      var key        = item.getAttribute('data-key');
      var removeLink = item.querySelector('[data-remove-item]');

      if (removeLink) {
        removeLink.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.classList.contains('is-removing')) return; /* guard double-click */

          TAAR.Cart.updateItem(key, 0)
            .then(function () { animateRemove(item, refreshSummary); })
            .catch(function () {
              TAAR.Toast.show('Could not update your bag — please try again');
            });
        });
      }
    });

    function animateRemove(item, done) {
      item.classList.add('is-removing');
      setTimeout(function () {
        if (item.parentNode) item.parentNode.removeChild(item);
        if (typeof done === 'function') done();
      }, 340);
    }

    function refreshSummary() {
      TAAR.Cart.getState().then(function (cart) {
        if (subtotalEl) {
          subtotalEl.textContent = TAAR.Util.formatMoney(cart.total_price);
        }
        if (countEl) {
          countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' piece' : ' pieces');
        }
        /* Reload page when cart becomes empty so empty state renders from server */
        if (cart.item_count === 0) {
          window.location.reload();
        }
      });
    }
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('collection-hero', function init(el) {
  var image = el.querySelector('.collection-hero__image');
  if (!image) return;

  if (window.IntersectionObserver) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          el.classList.add('in-view');
          obs.disconnect();
        }
      });
    }, { threshold: 0.05 });
    obs.observe(el);
  }

  TAAR.Animations.refresh(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  'use strict';

  TAAR.SectionRegistry.register('collection',
    function init(el) {
      var filterForm = el.querySelector('#CollectionFiltersForm');
      var filterOpenBtn = el.querySelector('[data-filter-open]');
      var isMobileDrawerOpen = false;

      // Accordion toggle
      el.addEventListener('click', function(e) {
        var summary = e.target.closest('.filter-group__summary');
        if (summary) {
          var expanded = summary.getAttribute('aria-expanded') === 'true';
          summary.setAttribute('aria-expanded', !expanded);
          return;
        }

        if (e.target.closest('[data-filter-close]')) {
          closeMobileDrawer();
        }
      });

      // AJAX form submit
      if (filterForm) {
        el.addEventListener('change', function(e) {
          if (e.target.hasAttribute('data-filter-input')) {
            var currentFilterForm = el.querySelector('#CollectionFiltersForm');
            if (!currentFilterForm) return;

            var formData = new FormData(currentFilterForm);
            var searchParams = new URLSearchParams(formData);
            
            // Build URL
            var url = window.location.pathname + '?' + searchParams.toString();
            
            // Fetch new section HTML
            fetch(url)
              .then(res => res.text())
              .then(html => {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                
                // Update specific elements
                ['#CollectionSidebar', '#ProductGrid', '.collection-active-filters', '#CollectionPagination'].forEach(selector => {
                  var source = doc.querySelector(selector);
                  var target = el.querySelector(selector);
                  if (source && target) {
                    target.innerHTML = source.innerHTML;
                  } else if (!source && target) {
                    target.innerHTML = '';
                  } else if (source && !target) {
                    // It means it was empty before, let's replace the whole main container
                    el.querySelector('#CollectionMain').innerHTML = doc.querySelector('#CollectionMain').innerHTML;
                  }
                });

                // Update URL history
                window.history.pushState({}, '', url);

                // Refresh animations and product cards
                TAAR.SectionRegistry.initAll(el.querySelector('#CollectionMain'));
                TAAR.Animations.refresh(el.querySelector('#CollectionMain'));
              });
          }
        });
      }

      // Mobile Drawer
      function openMobileDrawer() {
        if (isMobileDrawerOpen) return;
        isMobileDrawerOpen = true;
        document.body.classList.add('filter-drawer-open');
        TAAR.Util.lockScroll();
      }

      function closeMobileDrawer() {
        if (!isMobileDrawerOpen) return;
        isMobileDrawerOpen = false;
        document.body.classList.remove('filter-drawer-open');
        TAAR.Util.unlockScroll();
      }

      if (filterOpenBtn) {
        filterOpenBtn.addEventListener('click', openMobileDrawer);
      }

    }
  );
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["craft-story"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('craft-story', function init(el) {
  TAAR.Animations.refresh(el);

  var steps = el.querySelectorAll('[data-cs-step]');
  if (!steps.length) return;

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* No JS reveal support (or reduced motion): show everything open. */
  if (reduce || !('IntersectionObserver' in window)) {
    steps.forEach(function (s) { s.classList.add('is-open'); });
    return;
  }

  /* Only the step crossing the viewport's centre band stays open; as you
     scroll further, the previous step leaves the band and collapses again. */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle('is-open', entry.isIntersecting);
    });
  }, { threshold: 0, rootMargin: '-46% 0px -46% 0px' });

  steps.forEach(function (s) { io.observe(s); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drape-guide"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('drape-guide', function init(el) {
  TAAR.Animations.refresh(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-intro"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('editorial-intro', function init(el) {
  TAAR.Animations.refresh(el);

  var box = el.querySelector('[data-slideshow]');
  if (!box) return;

  // Safety net: guarantee the clip-reveal never leaves the media hidden, even
  // if the scroll observer fails to fire for this element.
  window.setTimeout(function () {
    if (!box.classList.contains('is-visible')) box.classList.add('is-visible');
  }, 1500);

  var slides = box.querySelectorAll('.editorial-intro__slide');
  if (slides.length < 2) return;

  // Respect reduced-motion: leave the first slide showing, no auto-advance.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var speed = parseInt(box.getAttribute('data-slideshow-speed'), 10) || 5000;
  var i = 0;
  el._eiSlideshow = window.setInterval(function () {
    slides[i].classList.remove('is-active');
    i = (i + 1) % slides.length;
    slides[i].classList.add('is-active');
  }, speed);
}, function destroy(el) {
  if (el._eiSlideshow) {
    window.clearInterval(el._eiSlideshow);
    el._eiSlideshow = null;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('featured-collection', function init(el) {
  TAAR.Animations.refresh(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  TAAR.SectionRegistry.register('site-header',

    function init(el) {
      var transparent    = el.hasAttribute('data-transparent');
      var navToggle      = el.querySelector('[data-nav-toggle]');
      var searchToggle   = el.querySelector('[data-search-toggle]');
      var cartToggle     = el.querySelector('[data-cart-toggle]');
      var megaItems      = Array.from(el.querySelectorAll('[data-mega-item]'));
      var backdrop       = el.querySelector('[data-mega-backdrop]');
      var wishlistBadge  = el.querySelector('#wishlist-count');
      var openMega       = null;
      var scrolled       = false;

      /* Header theme settings (wired from Header panel) */
      var scrollBehavior = el.getAttribute('data-scroll-behavior') || 'sticky';
      var megaMode       = el.getAttribute('data-mega-trigger-mode') || 'hover';
      var lastScrollY    = window.scrollY;

      /*
       * Scroll logic:
       *   Default (not scrolled) → floating pill with glass morphism.
       *   is-scrolled (y > 72)   → full-width flat header.
       *   behavior 'hide'        → additionally hide on scroll down, reveal on scroll up.
       * Smooth transition between all states via CSS.
       */
      var onScroll = TAAR.Util.throttle(function () {
        var y = window.scrollY;
        var nowScrolled = y > 32;
        if (nowScrolled !== scrolled) {
          scrolled = nowScrolled;
          el.classList.toggle('is-scrolled', scrolled);
        }

        if (scrollBehavior === 'hide') {
          if (y > lastScrollY && y > 200) {
            el.classList.add('is-hidden');
          } else if (y < lastScrollY) {
            el.classList.remove('is-hidden');
          }
        }
        lastScrollY = y;
      }, 60);

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      /* ── Mobile nav toggle ── */
      if (navToggle) {
        navToggle.addEventListener('click', function () {
          var expanded = navToggle.getAttribute('aria-expanded') === 'true';
          navToggle.setAttribute('aria-expanded', String(!expanded));
          TAAR.EventBus.emit(expanded ? 'nav:closed' : 'nav:opened');
        });
      }

      /* ── Search toggle ── */
      if (searchToggle) {
        searchToggle.addEventListener('click', function () {
          TAAR.EventBus.emit('search:opened');
        });
      }

      /* ── Cart toggle ──
         The bag is an anchor (no-JS fallback → cart page). With JS we stop the
         navigation and open the slide-out drawer instead, so it never jumps to
         checkout or reloads the page. */
      if (cartToggle) {
        cartToggle.addEventListener('click', function (e) {
          e.preventDefault();
          TAAR.EventBus.emit('cart:opened');
        });
      }

      /* ── Cart badge sync ── */
      var cartBadge = el.querySelector('[data-cart-toggle] .site-header__badge, [href*="cart"] .site-header__badge');
      TAAR.EventBus.on('cart:updated', function (data) {
        if (!cartBadge) return;
        var count = (data.cart && data.cart.item_count) || 0;
        cartBadge.textContent = count;
        cartBadge.style.display = count > 0 ? '' : 'none';
      });

      /* ── Wishlist badge sync ── */
      function updateWishlistBadge() {
        if (!wishlistBadge) return;
        var count = TAAR.Wishlist.count();
        wishlistBadge.textContent = count;
        wishlistBadge.style.display = count > 0 ? '' : 'none';
      }
      TAAR.EventBus.on('wishlist:added',   updateWishlistBadge);
      TAAR.EventBus.on('wishlist:removed', updateWishlistBadge);
      updateWishlistBadge();

      /* ── Mega menu ── */
      function closeMega() {
        if (!openMega) return;
        var trigger = openMega.querySelector('[data-mega-trigger]');
        var panel   = openMega.querySelector('.mega-menu');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel)   panel.hidden = true;
        if (backdrop) backdrop.hidden = true;
        openMega = null;
      }

      function openMegaFn(item) {
        if (openMega === item) return;
        closeMega();
        var trigger = item.querySelector('[data-mega-trigger]');
        var panel   = item.querySelector('.mega-menu');
        if (!panel) return;
        openMega = item;
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        if (backdrop) backdrop.hidden = false;
      }

      megaItems.forEach(function (item) {
        var trigger = item.querySelector('[data-mega-trigger]');

        if (megaMode === 'click') {
          /* Click mode: the parent link toggles the mega menu instead of
             opening on hover. Keyboard focus-out still closes it. */
          if (trigger) {
            trigger.addEventListener('click', function (e) {
              e.preventDefault();
              if (openMega === item) { closeMega(); } else { openMegaFn(item); }
            });
          }
          item.addEventListener('focusout', function (e) {
            if (!item.contains(e.relatedTarget)) closeMega();
          });
        } else {
          /* Hover mode (default) */
          item.addEventListener('mouseenter', function () { openMegaFn(item); });
          item.addEventListener('mouseleave', function () { closeMega(); });
          item.addEventListener('focusin',    function () { openMegaFn(item); });
          item.addEventListener('focusout',   function (e) {
            if (!item.contains(e.relatedTarget)) closeMega();
          });
        }

        if (trigger) {
          trigger.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') { closeMega(); trigger.focus(); }
          });
        }
      });

      if (backdrop) {
        backdrop.addEventListener('click', closeMega);
      }

      /* Close mega on Escape key */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && openMega) {
          var trigger = openMega.querySelector('[data-mega-trigger]');
          closeMega();
          if (trigger) trigger.focus();
        }
      });
    },

    function destroy() {
      /* scroll listener and event listeners are not tracked — section is never dynamically removed */
    }
  );
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('hero-banner', function init(section) {

  /* ── Position hero flush below the fixed header ──────────────────────
     The hero already flows beneath the (in-flow) announcement bar, so we
     only need to offset it by the header's own height — not its
     viewport-relative bottom, which would double-count the announcement
     bar and leave a gap. offsetHeight adapts to the mobile header height.
  ── */
  var header = document.querySelector('.site-header');
  function syncMargin() {
    if (!header) return;
    section.style.marginTop = header.offsetHeight + 'px';
  }
  syncMargin();
  window.addEventListener('resize', syncMargin);
  /* Re-sync after announcement bar close button is clicked */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-announcement-close], .announcement-bar__close, [data-close]')) {
      setTimeout(syncMargin, 320);
    }
  }, { passive: true });

  /* ── Entrance animation ─────────────────────────────────────────────── */
  var content = section.querySelector('[data-hero-content]');
  if (content && content.hasAttribute('data-hero-animate')) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        content.classList.add('hero-banner__content--animated');
      });
    });
  }

  /* ── Desktop image fallback for mobile ────────────────────────────────
     When no mobile image is uploaded, the desktop image has class
     --desktop-only (hidden on mobile via CSS). If no mobile image exists
     in the DOM we promote it to --all-sizes so it shows everywhere.
  ── */
  var desktopImg = section.querySelector('.hero-banner__img--desktop-only');
  var mobileImg  = section.querySelector('.hero-banner__img--mobile-only');
  if (desktopImg && !mobileImg) {
    desktopImg.classList.replace(
      'hero-banner__img--desktop-only',
      'hero-banner__img--all-sizes'
    );
  }

  /* ── Scroll indicator ─────────────────────────────────────────────────
     Fade the indicator out once the user starts scrolling.
  ── */
  var indicator = section.querySelector('[data-scroll-indicator]');
  if (indicator) {
    var hidden = false;
    var onScroll = TAAR.Util.throttle(function () {
      var shouldHide = window.scrollY > 80;
      if (shouldHide !== hidden) {
        hidden = shouldHide;
        indicator.classList.toggle('hero-banner__scroll--hidden', hidden);
      }
    }, 100);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Crossfade slideshow ─────────────────────────────────────────────── */
  var slideshow = section.querySelector('[data-hero-slideshow]');
  if (slideshow) {
    var slides   = slideshow.querySelectorAll('.hero-banner__slide');
    var interval = parseInt(slideshow.dataset.interval, 10) || 4000;
    var current  = 0;

    /* First-slide video (optional). Plays once, then the slideshow advances
       to the next slide. When the carousel wraps back to slide 1 the video
       rewinds and plays again. Respects prefers-reduced-motion. */
    var slideVideo   = slideshow.querySelector('[data-hero-slide-video]');
    var videoPoster  = slideshow.querySelector('.hero-banner__video-poster');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function resetVideoFrame() {
      if (slideVideo) slideVideo.classList.remove('is-ready');
      if (videoPoster) videoPoster.classList.remove('is-hidden');
    }

    function revealVideoFrame() {
      if (slideVideo) slideVideo.classList.add('is-ready');
      if (videoPoster) videoPoster.classList.add('is-hidden');
    }

    function syncSlideVideo(idx) {
      if (!slideVideo) return;
      if (idx === 0 && !reduceMotion) {
        resetVideoFrame();
        slideVideo.currentTime = 0;
        slideVideo.muted = true; /* guarantees muted autoplay on mobile browsers */
        var played = slideVideo.play();
        if (played && typeof played.catch === 'function') {
          played.catch(function () {
            /* Stay graceful if a browser blocks autoplay: move to the first
               banner rather than leaving the visitor on a black frame. */
            if (current === 0) goTo(current + 1);
          });
        }
      } else {
        slideVideo.pause();
        slideVideo.currentTime = 0;
      }
    }

    function getSlideType(idx) {
      if (slides[idx].classList.contains('hero-banner__slide--video')) return 'video';
      return 'photo';
    }

    function applySlide(idx) {
      section.setAttribute('data-active-slide', getSlideType(idx));
      syncSlideVideo(idx);
    }

    /* Crossfade to a specific slide. Wraps around in both directions so the
       loop stays infinite whether advancing automatically or via the arrows.
       Autoplay is paused when landing on a video slide (the video's own
       `ended` event will advance to the next slide). */
    function goTo(idx) {
      var target = (idx + slides.length) % slides.length;
      if (target === current) return;
      slides[current].classList.remove('hero-banner__slide--active');
      current = target;
      slides[current].classList.add('hero-banner__slide--active');
      applySlide(current);
      /* On video slides, stop the interval timer — the video's `ended`
         event handles the transition instead. On all other slides, make
         sure the interval timer is running. */
      if (isVideoSlide(current)) {
        stopAuto();
      } else {
        startAuto();
      }
    }

    /* Autoplay — interval timer runs only on non-video slides.
       The video slide relies on its `ended` event to advance. */
    var timer = null;
    function isVideoSlide(idx) {
      return slides[idx].classList.contains('hero-banner__slide--video');
    }
    function startAuto() {
      if (timer !== null) return;
      if (slides.length <= 1 || reduceMotion) return;
      if (isVideoSlide(current)) return;
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }
    function stopAuto() {
      if (timer !== null) { clearInterval(timer); timer = null; }
    }
    function resetAuto() {
      stopAuto();
      startAuto();
    }

    /* When the video finishes playing, advance to the next slide and
       kick off the interval timer for the remaining (image) slides. */
    if (slideVideo) {
      slideVideo.addEventListener('playing', revealVideoFrame);
      slideVideo.addEventListener('error', function () {
        resetVideoFrame();
        if (current === 0) goTo(current + 1);
      });
      slideVideo.addEventListener('ended', function () {
        if (current === 0) goTo(current + 1);
      });
    }

    applySlide(0);
    /* Don't start interval timer on load if slide 0 is the video —
       the video's `ended` event will handle the first transition. */
    if (!isVideoSlide(0)) {
      startAuto();
    }

    /* Prev / next arrows. Manual navigation resets the autoplay timer so the
       chosen slide gets a full interval before the show advances again. */
    var prevBtn = section.querySelector('[data-hero-prev]');
    var nextBtn = section.querySelector('[data-hero-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(current - 1); resetAuto(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(current + 1); resetAuto(); });
    }
  }

  /* ── YouTube lite embed ───────────────────────────────────────────────
     The iframe is NOT rendered in Liquid to avoid loading YouTube's
     ~400KB script chain during page load. Instead a data attribute marks
     the container; we inject the iframe after the window load event
     using requestIdleCallback (or a 500ms setTimeout fallback) so the
     LCP image is painted first.
  ── */
  var ytLite = section.querySelector('[data-youtube-id]');
  if (ytLite) {
    var ytId    = ytLite.dataset.youtubeId;
    var ytTitle = ytLite.dataset.youtubeTitle || 'Background video';

    function injectYoutube() {
      var iframe = document.createElement('iframe');
      iframe.className = 'hero-banner__video-iframe';
      iframe.src =
        'https://www.youtube-nocookie.com/embed/' + ytId +
        '?autoplay=1&mute=1&loop=1&playlist=' + ytId +
        '&controls=0&modestbranding=1&rel=0&playsinline=1';
      iframe.allow = 'autoplay; encrypted-media';
      iframe.setAttribute('tabindex', '-1');
      iframe.setAttribute('title', ytTitle);
      iframe.setAttribute('aria-hidden', 'true');
      ytLite.appendChild(iframe);
    }

    if (typeof window.requestIdleCallback === 'function') {
      window.addEventListener('load', function () {
        requestIdleCallback(injectYoutube, { timeout: 2000 });
      }, { once: true });
    } else {
      window.addEventListener('load', function () {
        setTimeout(injectYoutube, 500);
      }, { once: true });
    }
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-preview"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('journal-preview', function init(el) {
  TAAR.Animations.refresh(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('lookbook', function init(el) {
  var hotspots = Array.from(el.querySelectorAll('.lookbook__hotspot'));
  var image    = el.querySelector('.lookbook__image');

  /* ── Card direction based on hotspot position ── */
  hotspots.forEach(function (hs) {
    var x = parseFloat(hs.dataset.hotspotX || 50);
    var y = parseFloat(hs.dataset.hotspotY || 50);
    if (x > 65) hs.classList.add('lookbook__hotspot--opens-left');
    if (y > 58) hs.classList.add('lookbook__hotspot--opens-up');
  });

  /* ── Touch: first tap shows card, second tap navigates ── */
  var touchDevice = window.matchMedia('(hover: none)').matches;
  if (touchDevice) {
    hotspots.forEach(function (hs) {
      hs.addEventListener('click', function (e) {
        if (!hs.classList.contains('is-active')) {
          e.preventDefault();
          hotspots.forEach(function (h) { h.classList.remove('is-active'); });
          hs.classList.add('is-active');
          /* Make the internal link follow-able on second tap */
          var link = hs.querySelector('.lookbook__card-link');
          if (link) link.removeAttribute('tabindex');
        }
      });
    });

    /* Close on outside tap */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.lookbook__hotspot')) {
        hotspots.forEach(function (h) { h.classList.remove('is-active'); });
      }
    });
  }

  /* ── Keyboard: Enter/Space to toggle card ── */
  hotspots.forEach(function (hs) {
    hs.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var isActive = hs.classList.toggle('is-active');
        if (isActive) {
          hotspots.forEach(function (h) { if (h !== hs) h.classList.remove('is-active'); });
        }
      }
      if (e.key === 'Escape') {
        hs.classList.remove('is-active');
        hs.blur();
      }
    });
  });

  /* ── Slow image drift on scroll into view ── */
  if (image && window.IntersectionObserver) {
    var driftObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          el.classList.add('in-view');
          driftObserver.disconnect();
        }
      });
    }, { threshold: 0.05 });
    driftObserver.observe(el);
  }

  TAAR.Animations.refresh(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  TAAR.SectionRegistry.register('mobile-nav',

    function init(el) {
      var drawer          = el.querySelector('.mobile-nav__drawer');
      var overlay         = el.querySelector('[data-nav-overlay]');
      var closeBtn        = el.querySelector('[data-nav-close]');
      var backBtn         = el.querySelector('[data-nav-back]');
      var backLabel       = el.querySelector('[data-nav-back-label]');
      var primaryLevel    = el.querySelector('[data-nav-primary-level]');
      var subLevels       = Array.from(el.querySelectorAll('[data-nav-sub-level]'));
      var parentBtns      = Array.from(el.querySelectorAll('[data-nav-parent]'));
      var searchBtn       = el.querySelector('[data-nav-search-btn]');
      var isOpen          = false;
      var releaseFocus    = null;
      var previousFocus   = null;
      var currentSubLevel = null;

      function getFocusables() {
        return Array.from(el.querySelectorAll('[data-nav-focusable]:not([hidden])'))
          .filter(function (f) { return !f.closest('[hidden]'); });
      }

      function openNav() {
        if (isOpen) return;
        isOpen = true;
        previousFocus = document.activeElement;
        el.hidden = false;
        el.setAttribute('aria-hidden', 'false');

        requestAnimationFrame(function () {
          el.classList.add('is-open');
        });

        TAAR.Util.lockScroll();
        releaseFocus = TAAR.Util.trapFocus(drawer, closeBtn);
        TAAR.EventBus.emit('nav:opened');
      }

      function closeNav() {
        if (!isOpen) return;
        isOpen = false;
        el.classList.remove('is-open');

        /* Wait for transition before hiding */
        drawer.addEventListener('transitionend', function onEnd() {
          drawer.removeEventListener('transitionend', onEnd);
          el.hidden = true;
          el.setAttribute('aria-hidden', 'true');
          showPrimaryLevel();
        }, { once: true });

        TAAR.Util.unlockScroll();
        if (releaseFocus) { releaseFocus(); releaseFocus = null; }
        if (previousFocus) { previousFocus.focus(); previousFocus = null; }
        TAAR.EventBus.emit('nav:closed');
      }

      function showPrimaryLevel() {
        if (primaryLevel) primaryLevel.hidden = false;
        subLevels.forEach(function (lvl) { lvl.hidden = true; });
        if (backBtn) backBtn.hidden = true;
        currentSubLevel = null;
      }

      function showSubLevel(idx) {
        var sub = subLevels.find(function (lvl) {
          return lvl.dataset.navLevel === String(idx);
        });
        if (!sub) return;

        if (primaryLevel) primaryLevel.hidden = true;
        subLevels.forEach(function (lvl) { lvl.hidden = true; });
        sub.hidden = false;
        currentSubLevel = idx;

        if (backBtn) {
          backBtn.hidden = false;
          /* Update back label to parent title */
          var parent = el.querySelector('[data-nav-parent="' + idx + '"]');
          if (backLabel && parent) {
            backLabel.textContent = parent.textContent.trim();
          }
        }

        /* Move focus to first link in sub-level */
        var firstFocusable = sub.querySelector('[data-nav-focusable]');
        if (firstFocusable) firstFocusable.focus();
      }

      /* Parent link buttons (show sub-level) */
      parentBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          showSubLevel(parseInt(btn.dataset.navParent, 10));
        });
      });

      /* Back button */
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          showPrimaryLevel();
          /* Return focus to the parent button */
          var activeParent = el.querySelector('[data-nav-parent="' + currentSubLevel + '"]');
          if (activeParent) activeParent.focus();
        });
      }

      /* Close button and overlay */
      if (closeBtn)  closeBtn.addEventListener('click', closeNav);
      if (overlay)   overlay.addEventListener('click', closeNav);

      /* Escape key */
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          if (currentSubLevel !== null) {
            var parentBtn = el.querySelector('[data-nav-parent="' + currentSubLevel + '"]');
            showPrimaryLevel();
            if (parentBtn) parentBtn.focus();
          } else {
            closeNav();
          }
        }
      });

      /* Search shortcut */
      if (searchBtn) {
        searchBtn.addEventListener('click', function () {
          closeNav();
          TAAR.EventBus.emit('search:opened');
        });
      }

      /* EventBus — header hamburger triggers open/close */
      TAAR.EventBus.on('nav:opened', function () {
        if (!isOpen) openNav();
      });
      TAAR.EventBus.on('nav:closed', function () {
        if (isOpen) closeNav();
      });
    },

    function destroy() {}
  );
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('newsletter', function init(el) {
  TAAR.Animations.refresh(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occasion-navigator"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  TAAR.SectionRegistry.register('occasion-navigator', function init(el) {
    if (el._occasionCarouselCleanup) el._occasionCarouselCleanup();

    var carousels = Array.from(el.querySelectorAll('[data-occasion-carousel]'));
    if (!carousels.length) return;

    var autoplayEnabled = el.dataset.carouselAutoplay === 'true';
    var interval = parseInt(el.dataset.carouselInterval, 10) || 5000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var states = [];
    var observer = null;
    var destroyed = false;
    var requestController = window.AbortController ? new AbortController() : null;

    function normalizeTag(tag) {
      return String(tag || '').trim().toLowerCase();
    }

    function productImage(product) {
      if (!product || !product.images || !product.images.length) return null;
      return product.images[0];
    }

    function sizedImageUrl(src) {
      try {
        var url = new URL(src, window.location.origin);
        url.searchParams.set('width', '900');
        return url.toString();
      } catch (error) {
        return src;
      }
    }

    function activeElsewhere(state, productId) {
      return states.some(function (other) {
        return other !== state && (other.currentProductId === productId || other.pendingProductId === productId);
      });
    }

    function availableIndex(state, direction) {
      var count = state.products.length;
      for (var offset = 1; offset <= count; offset += 1) {
        var candidate = (state.index + (offset * direction) + count) % count;
        if (!activeElsewhere(state, state.products[candidate].id)) return candidate;
      }
      return (state.index + direction + count) % count;
    }

    function statusText(state) {
      return state.statusTemplate
        .replace('__CURRENT__', String(state.index + 1))
        .replace('__TOTAL__', String(state.products.length));
    }

    function render(state, announce) {
      var product = state.products[state.index];
      var imageData = productImage(product);
      if (!product || !imageData) return;

      state.renderToken += 1;
      var renderToken = state.renderToken;
      state.transitioning = true;
      state.pendingProductId = product.id;
      if (state.transitionTimer) window.clearTimeout(state.transitionTimer);
      if (state.copyTimer) window.clearTimeout(state.copyTimer);

      var nextSrc = sizedImageUrl(imageData.src);
      var incomingImage = new Image();
      incomingImage.className = 'occasion-nav__img occasion-nav__img--incoming';
      /* Detached lazy images may never start loading, which leaves the
         carousel transition locked. Carousel navigation is user-visible,
         so request the next image immediately. */
      incomingImage.loading = 'eager';
      incomingImage.decoding = 'async';
      incomingImage.alt = product.title || '';
      if (imageData.width) incomingImage.width = imageData.width;
      if (imageData.height) incomingImage.height = imageData.height;

      incomingImage.onload = function () {
        if (destroyed || renderToken !== state.renderToken) return;

        var oldImage = state.media.querySelector('.occasion-nav__img');
        var placeholder = state.media.querySelector('.occasion-nav__placeholder');
        var overlay = state.media.querySelector('.occasion-nav__overlay');
        if (placeholder) placeholder.remove();
        state.media.insertBefore(incomingImage, overlay || null);
        state.root.classList.add('is-updating-copy');

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (destroyed || renderToken !== state.renderToken) return;
            incomingImage.classList.remove('occasion-nav__img--incoming');
            if (oldImage && oldImage !== incomingImage) oldImage.classList.add('occasion-nav__img--leaving');
          });
        });

        var copyDelay = reduceMotion ? 0 : 300;
        var transitionDelay = reduceMotion ? 0 : 740;

        state.copyTimer = window.setTimeout(function () {
          if (destroyed || renderToken !== state.renderToken) return;
          if (state.productName) state.productName.textContent = product.title || '';
          state.root.classList.remove('is-updating-copy');
        }, copyDelay);

        state.transitionTimer = window.setTimeout(function () {
          if (destroyed || renderToken !== state.renderToken) return;
          if (oldImage && oldImage !== incomingImage) oldImage.remove();
          if (announce && state.status) state.status.textContent = statusText(state);
          state.currentProductId = product.id;
          state.pendingProductId = null;
          state.transitioning = false;
        }, transitionDelay);
      };
      incomingImage.onerror = function () {
        if (renderToken !== state.renderToken) return;
        state.pendingProductId = null;
        state.transitioning = false;
        state.root.classList.remove('is-updating-copy');
      };
      incomingImage.src = nextSrc;

      var nextIndex = (state.index + 1) % state.products.length;
      var nextImage = productImage(state.products[nextIndex]);
      if (nextImage) {
        var preloader = new Image();
        preloader.src = sizedImageUrl(nextImage.src);
      }
    }

    function stop(state) {
      if (state.timer) window.clearInterval(state.timer);
      state.timer = null;
    }

    function start(state) {
      stop(state);
      if (!autoplayEnabled || reduceMotion || state.paused || state.offscreen || document.hidden || state.products.length < 2) return;
      state.timer = window.setInterval(function () {
        state.index = availableIndex(state, 1);
        render(state, false);
      }, interval);
    }

    function move(state, direction) {
      stop(state);
      state.index = availableIndex(state, direction);
      render(state, true);
      start(state);
    }

    function prepare(products) {
      carousels.forEach(function (root) {
        var configuredTags = (root.dataset.productTags || '')
          .split('|')
          .map(normalizeTag)
          .filter(Boolean);
        var matches = products.filter(function (product) {
          var tags = (product.tags || []).map(normalizeTag);
          return configuredTags.some(function (tag) { return tags.indexOf(tag) !== -1; });
        }).filter(function (product) { return productImage(product); });

        var state = {
          root: root,
          products: matches,
          index: -1,
          currentProductId: null,
          pendingProductId: null,
          renderToken: 0,
          media: root.querySelector('[data-carousel-media]'),
          productName: root.querySelector('[data-carousel-product-name]'),
          prev: root.querySelector('[data-carousel-prev]'),
          next: root.querySelector('[data-carousel-next]'),
          status: root.querySelector('[data-carousel-status]'),
          statusTemplate: root.dataset.statusTemplate || 'Product __CURRENT__ of __TOTAL__',
          timer: null,
          transitionTimer: null,
          copyTimer: null,
          transitioning: false,
          paused: false,
          offscreen: false
        };

        if (!matches.length || !state.media) return;
        states.push(state);

        state.index = availableIndex(state, 1);
        render(state, false);

        if (matches.length > 1) {
          state.prev.hidden = false;
          state.next.hidden = false;
        }

        state.onPrevious = function () { move(state, -1); };
        state.onNext = function () { move(state, 1); };
        state.onFocusIn = function () { state.paused = true; stop(state); };
        state.onFocusOut = function (event) {
          if (root.contains(event.relatedTarget)) return;
          state.paused = false;
          start(state);
        };

        state.prev.addEventListener('click', state.onPrevious);
        state.next.addEventListener('click', state.onNext);
        root.addEventListener('focusin', state.onFocusIn);
        root.addEventListener('focusout', state.onFocusOut);
      });

      states.forEach(start);

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var state = states.find(function (candidate) { return candidate.root === entry.target; });
            if (!state) return;
            state.offscreen = !entry.isIntersecting;
            if (state.offscreen) stop(state);
            else start(state);
          });
        }, { threshold: 0.08 });
        states.forEach(function (state) { observer.observe(state.root); });
      }
    }

    function onVisibilityChange() {
      states.forEach(function (state) {
        if (document.hidden) stop(state);
        else start(state);
      });
    }

    document.addEventListener('visibilitychange', onVisibilityChange);

    var requestOptions = { headers: { Accept: 'application/json' } };
    if (requestController) requestOptions.signal = requestController.signal;
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'products.json?limit=250', requestOptions)
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load occasion products');
        return response.json();
      })
      .then(function (data) {
        if (!destroyed) prepare(data.products || []);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') console.warn('[Occasion navigator]', error.message);
      });

    el._occasionCarouselCleanup = function () {
      destroyed = true;
      if (requestController) requestController.abort();
      if (observer) observer.disconnect();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      states.forEach(function (state) {
        stop(state);
        if (state.transitionTimer) window.clearTimeout(state.transitionTimer);
        if (state.copyTimer) window.clearTimeout(state.copyTimer);
        state.renderToken += 1;
        state.prev.removeEventListener('click', state.onPrevious);
        state.next.removeEventListener('click', state.onNext);
        state.root.removeEventListener('focusin', state.onFocusIn);
        state.root.removeEventListener('focusout', state.onFocusOut);
      });
    };

    TAAR.Animations.refresh(el);
  }, function destroy(el) {
    if (el._occasionCarouselCleanup) el._occasionCarouselCleanup();
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('product-grid', function init(el) {
  TAAR.Animations.refresh(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  'use strict';

  TAAR.SectionRegistry.register('product',
    function init(el) {
      var form = el.querySelector('form.product-form');
      var atcBtn = el.querySelector('.product-form__add-btn');
      var atcText = el.querySelector('[data-add-to-cart-text]');

      // Sticky ATC
      var stickyATC = el.querySelector('[data-sticky-atc]');
      var stickySubmit = el.querySelector('[data-sticky-submit]');
      var stickyPrice = el.querySelector('[data-sticky-price]');
      var stickyText = el.querySelector('[data-sticky-atc-text]');
      
      var variantsData = el.querySelector('[data-variants-json]');
      var variants = variantsData ? JSON.parse(variantsData.textContent) : [];

      // Handle variant change
      TAAR.EventBus.on('variant:changed', function(data) {
        // Validate if this section's product matches the event's product id, to avoid conflicts if multiple product sections exist
        if (data.productId !== parseInt(el.getAttribute('data-product-id'), 10)) return;

        var variant = data.variant;
        
        // Update URL
        if (!variant) return;
        window.history.replaceState({ }, '', '?variant=' + variant.id);

        // Update add to cart buttons
        if (variant.available) {
          atcBtn.removeAttribute('disabled');
          atcText.textContent = 'Add to Bag';
          if (stickySubmit) {
            stickySubmit.removeAttribute('disabled');
            stickyText.textContent = 'Add to Bag';
          }
        } else {
          atcBtn.setAttribute('disabled', 'disabled');
          atcText.textContent = 'Sold out';
          if (stickySubmit) {
            stickySubmit.setAttribute('disabled', 'disabled');
            stickyText.textContent = 'Sold out';
          }
        }

        // Update price displays (this section has its own price snippet which will be updated by its own JS or we need to update it here)
        // Since component-variant-picker usually doesn't update the DOM of price outside of it, we should re-render or update price manually
        if (stickyPrice) stickyPrice.textContent = TAAR.Util.formatMoney(variant.price);
        
        // Actually, for price snippet in product page, we can fetch section rendering API, but a simpler way is to let the event bus trigger price updates in the future, or manually format.
        var priceEl = el.querySelector('.price__regular');
        if (priceEl) priceEl.textContent = TAAR.Util.formatMoney(variant.price);

        /* Keep a saved item tied to the variant the customer is viewing. */
        if (wishlistBtn) {
          wishlistBtn.setAttribute('data-variant-id', variant.id);
          wishlistBtn.setAttribute('data-price', variant.price);
        }
      });

      // Form submission (AJAX Cart)
      if (form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var formData = new FormData(form);
          var id = formData.get('id');
          var qty = formData.get('quantity');

          atcBtn.classList.add('is-loading');

          TAAR.Cart.addItem(id, qty)
            .then(function() {
              atcBtn.classList.remove('is-loading');
              atcBtn.classList.add('is-added');
              if (atcText) atcText.textContent = 'Added';
              setTimeout(function() {
                atcBtn.classList.remove('is-added');
                if (atcText) atcText.textContent = 'Add to Bag';
              }, 2000);
            })
            .catch(function(err) {
              console.error(err);
              atcBtn.classList.remove('is-loading');
              TAAR.Toast.show('Could not add to cart — please try again');
            });
        });
      }

      // Sticky Submit proxy
      if (stickySubmit && form) {
        stickySubmit.addEventListener('click', function() {
          form.dispatchEvent(new Event('submit'));
        });
      }

      // Intersection Observer for Sticky ATC
      if (stickyATC && atcBtn) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              stickyATC.classList.remove('is-visible');
              stickyATC.setAttribute('hidden', '');
            } else {
              stickyATC.classList.add('is-visible');
              stickyATC.removeAttribute('hidden');
            }
          });
        });
        observer.observe(atcBtn);
      }

      // ── Product Gallery — thumbnails + lightbox ──────────────────────────
      // Keep long editorial descriptions compact until the customer asks for more.
      var descriptionWrap = el.querySelector('[data-product-description-wrap]');
      var description = el.querySelector('[data-product-description]');
      var descriptionToggle = el.querySelector('[data-product-description-toggle]');
      var descriptionCollapsedHeight = 0;
      var descriptionExpandedHeight = 0;
      if (descriptionWrap && description && descriptionToggle) {
        requestAnimationFrame(function () {
          descriptionCollapsedHeight = description.clientHeight;
          descriptionExpandedHeight = description.scrollHeight;
          if (descriptionExpandedHeight <= descriptionCollapsedHeight + 2) {
            descriptionToggle.hidden = true;
          } else {
            descriptionWrap.style.setProperty('--product-description-expanded-height', descriptionExpandedHeight + 'px');
          }
        });
        descriptionToggle.addEventListener('click', function () {
          var expanded = descriptionWrap.classList.toggle('is-expanded');
          descriptionToggle.textContent = expanded ? 'Read less' : 'Read more';
        });
      }

      var gallery      = el.querySelector('[data-product-gallery]');
      var thumbBtns    = gallery ? Array.from(gallery.querySelectorAll('.product-media__thumb')) : [];
      var mediaItems   = Array.from(el.querySelectorAll('.product-media__item[data-media-index]'));
      var mediaPrev    = gallery && gallery.querySelector('[data-product-media-prev]');
      var mediaNext    = gallery && gallery.querySelector('[data-product-media-next]');
      var lightbox     = el.querySelector('[data-lightbox]');
      var lbImg        = lightbox && lightbox.querySelector('.product-lightbox__image');
      var lbClose      = lightbox && lightbox.querySelector('.product-lightbox__close');
      var lbPrev       = lightbox && lightbox.querySelector('.product-lightbox__prev');
      var lbNext       = lightbox && lightbox.querySelector('.product-lightbox__next');
      var lbCurrent    = lightbox && lightbox.querySelector('[data-lb-current]');
      var currentLbIdx = 0;

      function setActiveThumb(idx) {
        thumbBtns.forEach(function (thumb) {
          var thumbIndex = parseInt(thumb.getAttribute('data-thumb-index'), 10);
          var isActive = thumbIndex === idx;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function activateMedia(idx) {
        if (!mediaItems.length || idx < 0 || idx >= mediaItems.length) return;
        mediaItems.forEach(function (item) {
          var itemIndex = parseInt(item.getAttribute('data-media-index'), 10);
          var isActive = itemIndex === idx;
          item.classList.toggle('is-active', isActive);
          item.hidden = !isActive;
        });
        currentLbIdx = idx;
        setActiveThumb(idx);
      }

      /* Click thumbnail → scroll to gallery item */
      thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          activateMedia(parseInt(btn.getAttribute('data-thumb-index'), 10));
        });
      });

      /* Update active thumb as gallery scrolls into view */
      if (mediaPrev) {
        mediaPrev.addEventListener('click', function () {
          activateMedia((currentLbIdx - 1 + mediaItems.length) % mediaItems.length);
        });
      }
      if (mediaNext) {
        mediaNext.addEventListener('click', function () {
          activateMedia((currentLbIdx + 1) % mediaItems.length);
        });
      }

      /* Click main image → open lightbox */
      mediaItems.forEach(function (item) {
        item.addEventListener('click', function () {
          if (item.querySelector('.product-media__image')) {
            openLightbox(parseInt(item.getAttribute('data-media-index'), 10));
          }
        });
      });

      function openLightbox(idx) {
        if (!lightbox) return;
        currentLbIdx = idx;
        showLightboxImage(idx);
        lightbox.showModal();
        TAAR.Util.lockScroll();
      }

      function closeLightbox() {
        if (!lightbox) return;
        lightbox.close();
        TAAR.Util.unlockScroll();
      }

      function showLightboxImage(idx) {
        var item = mediaItems[idx];
        var img  = item && item.querySelector('.product-media__image');
        if (!img || !lbImg) return false;
        lbImg.classList.add('is-loading');
        lbImg.onload = function () { lbImg.classList.remove('is-loading'); };
        lbImg.src = img.currentSrc || img.src;
        lbImg.alt = img.alt || '';
        if (lbCurrent) lbCurrent.textContent = idx + 1;
        return true;
      }

      function findImageIndex(start, step) {
        for (var offset = 1; offset <= mediaItems.length; offset += 1) {
          var candidate = (start + (step * offset) + mediaItems.length) % mediaItems.length;
          if (mediaItems[candidate].querySelector('.product-media__image')) return candidate;
        }
        return start;
      }

      if (lbClose) lbClose.addEventListener('click', closeLightbox);

      if (lbPrev) {
        lbPrev.addEventListener('click', function () {
          currentLbIdx = findImageIndex(currentLbIdx, -1);
          showLightboxImage(currentLbIdx);
        });
      }

      if (lbNext) {
        lbNext.addEventListener('click', function () {
          currentLbIdx = findImageIndex(currentLbIdx, 1);
          showLightboxImage(currentLbIdx);
        });
      }

      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) closeLightbox();
        });
        lightbox.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') {
            currentLbIdx = findImageIndex(currentLbIdx, -1);
            showLightboxImage(currentLbIdx);
          } else if (e.key === 'ArrowRight') {
            currentLbIdx = findImageIndex(currentLbIdx, 1);
            showLightboxImage(currentLbIdx);
          }
        });
        lightbox.addEventListener('close', function () { TAAR.Util.unlockScroll(); });
      }

      // ── Wishlist init (handled by global wishlist listener on data-wishlist-btn but let's toggle active state)
      var wishlistBtn = el.querySelector('[data-wishlist-btn]');
      if (wishlistBtn) {
        var pid = parseInt(wishlistBtn.getAttribute('data-product-id'), 10);

        function syncWishlistButton() {
          var active = TAAR.Wishlist.has(pid);
          var label = active
            ? (wishlistBtn.getAttribute('data-label-active') || 'Remove from wishlist')
            : (wishlistBtn.getAttribute('data-label-inactive') || 'Add to wishlist');
          wishlistBtn.classList.toggle('is-active', active);
          wishlistBtn.setAttribute('aria-pressed', String(active));
          wishlistBtn.setAttribute('aria-label', label);
          var labelEl = wishlistBtn.querySelector('[data-wishlist-label]');
          if (labelEl) labelEl.textContent = label;
        }

        syncWishlistButton();
        TAAR.EventBus.on('wishlist:added', syncWishlistButton);
        TAAR.EventBus.on('wishlist:removed', syncWishlistButton);

        wishlistBtn.addEventListener('click', function(e) {
          e.preventDefault();
          TAAR.Wishlist.toggle({
            id: pid,
            variantId: parseInt(wishlistBtn.getAttribute('data-variant-id'), 10),
            handle: wishlistBtn.getAttribute('data-handle'),
            title: wishlistBtn.getAttribute('data-title'),
            price: parseInt(wishlistBtn.getAttribute('data-price'), 10),
            image: wishlistBtn.getAttribute('data-image') || '',
            url: wishlistBtn.getAttribute('data-url') || '',
            requiresOptions: false
          });
        });
      }
    }
  );
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
(function () {
  'use strict';

  var STORAGE_KEY = 'taar_recently_viewed';
  var MAX_ITEMS = 4;

  function getRecentHandles() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function addRecentHandle(handle) {
    if (!handle) return;
    var handles = getRecentHandles();
    handles = handles.filter(function(h) { return h !== handle; });
    handles.unshift(handle);
    if (handles.length > MAX_ITEMS) handles.pop();
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
  }

  // If we are on a product page, add the current product to localStorage
  // We can determine this if window.location.pathname contains /products/
  var match = window.location.pathname.match(/\/products\/([^/]+)/);
  var currentHandle = match ? match[1] : null;
  if (currentHandle) {
    // delay slightly so we don't fetch ourselves immediately in the recently viewed section below
    setTimeout(function() {
      addRecentHandle(currentHandle);
    }, 1000);
  }

  TAAR.SectionRegistry.register('recently-viewed',
    function init(el) {
      var container = el.querySelector('[data-recently-viewed-container]');
      if (!container) return; // Means we are already populated via search

      var handles = getRecentHandles();
      if (currentHandle) {
        handles = handles.filter(function(h) { return h !== currentHandle; });
      }

      if (handles.length === 0) {
        el.style.display = 'none';
        return;
      }

      var query = handles.map(function(h) { return 'handle:' + h; }).join(' OR ');
      var url = window.routes ? window.routes.search_url : '/search';
      url += '?type=product&q=' + encodeURIComponent(query) + '&section_id=' + el.getAttribute('data-section-id');

      fetch(url)
        .then(response => response.text())
        .then(text => {
          var html = document.createElement('div');
          html.innerHTML = text;
          var newContent = html.querySelector('.recently-viewed');

          if (newContent && newContent.querySelector('.product-grid')) {
            el.innerHTML = newContent.innerHTML;
            el.style.display = 'block';
            TAAR.Animations.refresh(el);
          } else {
            el.style.display = 'none';
          }
        })
        .catch(e => {
          console.error(e);
          el.style.display = 'none';
        });
    }
  );
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  'use strict';

  TAAR.SectionRegistry.register('related-products',
    function init(el) {
      var url = el.getAttribute('data-url');
      if (!url) return;

      // Only fetch if not already performed (so we don't loop on section reload)
      if (el.querySelector('.related-products__header')) return;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          var html = document.createElement('div');
          html.innerHTML = text;
          var recommendations = html.querySelector('.related-products');

          if (recommendations && recommendations.innerHTML.trim().length > 0) {
            el.innerHTML = recommendations.innerHTML;
            
            // Re-init animations for new DOM elements
            TAAR.Animations.refresh(el);
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  );
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
TAAR.SectionRegistry.register('search', function init(el) {
  TAAR.Animations.refresh(el);

  /* Auto-focus the search input on page load if no query has been entered yet */
  var input = el.querySelector('.search-page__input');
  if (input && !input.value) {
    setTimeout(function () { input.focus(); }, 200);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  TAAR.SectionRegistry.register('shop-by-category', function init(el) {
    var tabs = Array.from(el.querySelectorAll('[data-sbc-filter]'));
    var track = el.querySelector('[data-sbc-track]');
    if (!track || !tabs.length) return;

    var cards = Array.from(track.querySelectorAll('[data-sbc-product]'));
    var empty = el.querySelector('[data-sbc-empty]');
    var viewAll = el.querySelector('[data-sbc-view-all]');
    var prev = el.querySelector('[data-sbc-prev]');
    var next = el.querySelector('[data-sbc-next]');
    var categoryOrder = tabs
      .map(function (tab) { return tab.dataset.sbcFilter; })
      .filter(function (key) { return key !== 'all'; });
    var carouselEnabled = el.dataset.carousel === 'true';
    var autoplayEnabled = carouselEnabled && el.dataset.autoplay === 'true';
    var interval = parseInt(el.dataset.interval, 10) || 4000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cycleIds = [];
    var autoplayId = null;
    var isHovering = false;
    var isOffscreen = false;

    function cardPrice(card) {
      return parseInt(card.dataset.sbcPrice, 10) || 0;
    }

    function byPriceDesc(a, b) { return cardPrice(b) - cardPrice(a); }

    function orderedForAll() {
      var groups = {};
      categoryOrder.forEach(function (key) { groups[key] = []; });
      var other = [];

      cards.forEach(function (card) {
        var key = card.dataset.sbcCategory || 'other';
        if (groups[key]) groups[key].push(card);
        else other.push(card);
      });

      categoryOrder.forEach(function (key) { groups[key].sort(byPriceDesc); });
      other.sort(byPriceDesc);

      var depth = categoryOrder.reduce(function (max, key) {
        return Math.max(max, groups[key].length);
      }, 0);
      var ordered = [];
      for (var rank = 0; rank < depth; rank += 1) {
        categoryOrder.forEach(function (key) {
          if (groups[key][rank]) ordered.push(groups[key][rank]);
        });
      }
      return ordered.concat(other);
    }

    function visibleCards() {
      return cards.filter(function (card) { return !card.hidden; });
    }

    function stopImageCycling() {
      cycleIds.forEach(window.clearInterval);
      cycleIds = [];
    }

    function startImageCycling() {
      stopImageCycling();
      visibleCards().forEach(function (card, cardIndex) {
        var images = Array.from(card.querySelectorAll('.product-card__cycle-img'));
        if (images.length < 2) return;
        var current = 0;
        window.setTimeout(function () {
          var id = window.setInterval(function () {
            if (card.hidden) return;
            images[current].classList.remove('is-active');
            current = (current + 1) % images.length;
            images[current].classList.add('is-active');
          }, 4000);
          cycleIds.push(id);
        }, cardIndex * 350);
      });
    }

    function updateNavigation() {
      if (!carouselEnabled || !prev || !next) return;
      var canScroll = track.scrollWidth > track.clientWidth + 2;
      prev.hidden = !canScroll;
      next.hidden = !canScroll;
    }

    function stepSize() {
      var card = visibleCards()[0];
      if (!card) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function moveCarousel(direction) {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) return;
      var target = track.scrollLeft + (direction * stepSize());
      if (target > max - 2) target = 0;
      if (target < 0) target = max;
      track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function stopAutoplay() {
      if (autoplayId) window.clearInterval(autoplayId);
      autoplayId = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || reduceMotion || isHovering || isOffscreen || document.hidden) return;
      if (track.scrollWidth <= track.clientWidth + 2) return;
      autoplayId = window.setInterval(function () { moveCarousel(1); }, interval);
    }

    function showCategory(key, updateUrl) {
      var order;
      if (key === 'all') {
        order = orderedForAll();
        cards.forEach(function (card) { card.hidden = false; });
      } else {
        order = cards
          .filter(function (card) { return card.dataset.sbcCategory === key; })
          .sort(byPriceDesc);
        cards.forEach(function (card) { card.hidden = card.dataset.sbcCategory !== key; });
      }

      order.forEach(function (card) { track.appendChild(card); });

      tabs.forEach(function (tab) {
        var active = tab.dataset.sbcFilter === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });

      var activeTab = tabs.find(function (tab) { return tab.dataset.sbcFilter === key; });
      if (viewAll && activeTab && activeTab.dataset.sbcUrl) viewAll.href = activeTab.dataset.sbcUrl;
      if (empty) empty.hidden = visibleCards().length > 0;

      track.scrollLeft = 0;
      startImageCycling();
      window.requestAnimationFrame(function () {
        updateNavigation();
        startAutoplay();
        TAAR.Animations.refresh(track);
      });

      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (key === 'all') url.searchParams.delete('category');
        else url.searchParams.set('category', key);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        showCategory(tab.dataset.sbcFilter, true);
      });
    });

    el.addEventListener('keydown', function (event) {
      if (!event.target.hasAttribute('data-sbc-filter')) return;
      var index = tabs.indexOf(event.target);
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
      else return;
      event.preventDefault();
      tabs[index].focus();
      showCategory(tabs[index].dataset.sbcFilter, true);
    });

    if (prev) prev.addEventListener('click', function () { moveCarousel(-1); startAutoplay(); });
    if (next) next.addEventListener('click', function () { moveCarousel(1); startAutoplay(); });

    el.addEventListener('mouseenter', function () { isHovering = true; stopAutoplay(); });
    el.addEventListener('mouseleave', function () { isHovering = false; startAutoplay(); });
    el.addEventListener('focusin', function () { isHovering = true; stopAutoplay(); });
    el.addEventListener('focusout', function (event) {
      if (el.contains(event.relatedTarget)) return;
      isHovering = false;
      startAutoplay();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        isOffscreen = !entries[0].isIntersecting;
        if (isOffscreen) stopAutoplay();
        else startAutoplay();
      }, { threshold: 0.08 });
      observer.observe(el);
    }

    window.addEventListener('resize', function () {
      updateNavigation();
      startAutoplay();
    });

    var requested = new URLSearchParams(window.location.search).get('category');
    var initial = tabs.some(function (tab) { return tab.dataset.sbcFilter === requested; }) ? requested : 'all';
    showCategory(initial, false);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('testimonials', function init(el) {
  TAAR.Animations.refresh(el);

  /* Cursor-following white glow */
  var cursorGlow = el.querySelector('[data-cursor-glow]');
  if (cursorGlow) {
    var raf = null;
    el.addEventListener('pointermove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        var rect = el.getBoundingClientRect();
        el.style.setProperty('--rw-mx', (e.clientX - rect.left) + 'px');
        el.style.setProperty('--rw-my', (e.clientY - rect.top) + 'px');
        el.classList.add('is-glow-active');
        raf = null;
      });
    });
    el.addEventListener('pointerleave', function () {
      el.classList.remove('is-glow-active');
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-strip"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('trust-strip', function init(el) {});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weavers"] && !Shopify.designMode) return;
  try {
    
TAAR.SectionRegistry.register('weavers', function init(el) {
  var items = el.querySelectorAll('[data-video-index]');
  if (!items.length) return;

  var current = null;

  function stop(item) {
    if (!item) return;
    var video = item.querySelector('[data-video-element]');
    if (!video) return;
    video.pause();
    try { video.currentTime = 0; } catch (e) {}
    item.classList.remove('is-playing');
    if (current === video) current = null;
  }

  function play(item) {
    var video = item.querySelector('[data-video-element]');
    if (!video) return;
    if (current && current !== video) {
      stop(current.closest('[data-video-index]'));
    }
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
    item.classList.add('is-playing');
    current = video;
  }

  function toggle(item) {
    if (item.classList.contains('is-playing')) {
      stop(item);
    } else {
      play(item);
    }
  }

  items.forEach(function (item) {
    var video = item.querySelector('[data-video-element]');
    if (!video) return;
    item.addEventListener('click', function () { toggle(item); });
    video.addEventListener('ended', function () { stop(item); });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
(function () {
  'use strict';

  TAAR.SectionRegistry.register('wishlist', function init(el) {
    var loadingEl   = el.querySelector('[data-wishlist-loading]');
    var gridEl      = el.querySelector('[data-wishlist-grid]');
    var emptyEl     = el.querySelector('[data-wishlist-empty]');
    var badgeEl     = el.querySelector('[data-wishlist-count-badge]');
    var clearAllBtn = el.querySelector('[data-wishlist-clear-all]');

    /* ── Image helpers ── */

    /**
     * Generate srcset from a Shopify CDN URL by swapping the width parameter.
     * If the URL has &width=X or ?width=X, replaces it for each breakpoint.
     * Falls back to just the original src if no width param found.
     */
    function buildSrcset(url) {
      if (!url) return '';
      var widths = [300, 400, 600, 800];
      var hasWidthParam = /[?&]width=\d+/.test(url);

      if (hasWidthParam) {
        return widths.map(function (w) {
          return url.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w';
        }).join(', ');
      }

      /* Fallback: try the _WIDTHx format used by older Shopify CDN URLs */
      var hasUnderscoreWidth = /_\d+x\./.test(url);
      if (hasUnderscoreWidth) {
        return widths.map(function (w) {
          return url.replace(/_\d+x\./, '_' + w + 'x.') + ' ' + w + 'w';
        }).join(', ');
      }

      return '';
    }

    /**
     * Attempt to re-fetch the product image from Shopify's product JSON API
     * when the stored image URL fails. Updates localStorage for future visits.
     */
    function tryRefreshImage(imgEl, item) {
      if (!item.url) return;
      var jsonUrl = item.url.split('?')[0] + '.json';

      fetch(jsonUrl)
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (data) {
          if (!data || !data.product) return;
          var product = data.product;
          var newImage = '';

          if (product.featured_image) {
            newImage = product.featured_image;
          } else if (product.images && product.images.length > 0) {
            newImage = product.images[0].src || product.images[0];
          }

          if (newImage) {
            /* Ensure https */
            if (newImage.indexOf('//') === 0) newImage = 'https:' + newImage;
            imgEl.src = newImage;
            imgEl.srcset = buildSrcset(newImage);

            /* Update localStorage so next load is instant */
            var allItems = TAAR.Wishlist.getAll();
            allItems.forEach(function (existing) {
              if (String(existing.id) === String(item.id)) {
                existing.image = newImage;
              }
            });
            try {
              localStorage.setItem('taar_wishlist', JSON.stringify({ items: allItems }));
            } catch (_) {}
          }
        });
    }

    /**
     * Create a placeholder SVG element for broken/missing images.
     */
    function createPlaceholderHTML() {
      return '<div class="wishlist-card__image-placeholder">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">' +
          '<rect x="3" y="3" width="18" height="18" rx="2"/>' +
          '<circle cx="8.5" cy="8.5" r="1.5"/>' +
          '<path d="m21 15-5-5L5 21"/>' +
        '</svg>' +
        '<span>Image unavailable</span>' +
      '</div>';
    }

    /* ── Date formatting ── */
    function formatAddedDate(isoString) {
      if (!isoString) return '';
      try {
        var d = new Date(isoString);
        if (isNaN(d.getTime())) return '';
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return 'Saved ' + months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
      } catch (_) { return ''; }
    }

    /* ── UI state ── */

    function updateCountBadge(count) {
      if (!badgeEl) return;
      if (count > 0) {
        badgeEl.textContent = count;
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }
    }

    function hideLoading() {
      if (loadingEl) loadingEl.setAttribute('hidden', '');
    }

    function showEmpty() {
      hideLoading();
      if (clearAllBtn) clearAllBtn.style.display = 'none';
      if (emptyEl) {
        emptyEl.removeAttribute('hidden');
        TAAR.Animations.refresh(emptyEl);
      }
      updateCountBadge(0);
    }

    function showGrid() {
      hideLoading();
      if (gridEl) {
        gridEl.removeAttribute('hidden');
        TAAR.Animations.refresh(gridEl);
      }
      if (clearAllBtn) clearAllBtn.style.display = '';
      var count = gridEl ? gridEl.querySelectorAll('[data-wishlist-card]').length : 0;
      updateCountBadge(count);
    }

    /* ── Card rendering ── */

    function renderCard(item, index) {
      var card = document.createElement('div');
      card.className = 'wishlist-card';
      card.setAttribute('data-animate', '');
      /* Stagger animation: up to delay 8 */
      var delay = Math.min((index || 0) % 8, 7);
      card.setAttribute('data-animate-delay', String(delay));
      card.setAttribute('data-wishlist-card', '');
      card.setAttribute('data-product-id', item.id);

      var priceStr = TAAR.Util.formatMoney(item.price || 0);
      var dateStr = formatAddedDate(item.addedAt);

      var srcset = buildSrcset(item.image);
      var imgHtml = item.image
        ? '<img class="wishlist-card__image" src="' + escAttr(item.image) + '"' +
          (srcset ? ' srcset="' + escAttr(srcset) + '"' : '') +
          ' sizes="(min-width: 1200px) 22vw, (min-width: 768px) 30vw, 48vw"' +
          ' alt="' + escAttr(item.title || '') + '"' +
          ' loading="lazy" width="400" height="500"' +
          ' data-product-id="' + escAttr(String(item.id)) + '">'
        : createPlaceholderHTML();

      var canQuickAdd = !!item.variantId && !item.requiresOptions;

      card.innerHTML =
        '<div class="wishlist-card__media">' +
          '<a href="' + escAttr(item.url || '/') + '" class="wishlist-card__image-link" aria-label="' + escAttr(item.title || '') + '" tabindex="-1" aria-hidden="true">' +
            imgHtml +
          '</a>' +
          '<button type="button" class="wishlist-card__remove" data-remove aria-label="Remove from wishlist">' +
            '<svg viewBox="0 0 12 12" fill="none" width="10" height="10" aria-hidden="true">' +
              '<path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/>' +
            '</svg>' +
          '</button>' +
          '<div class="wishlist-card__quick-add">' +
            (canQuickAdd
              ? '<button type="button" class="wishlist-card__atb btn btn--primary btn--sm" data-atb>Add to Bag</button>'
              : '<a href="' + escAttr(item.url || '/') + '" class="wishlist-card__atb btn btn--primary btn--sm">Choose Options</a>'
            ) +
          '</div>' +
        '</div>' +
        '<div class="wishlist-card__info">' +
          '<h3 class="wishlist-card__title">' +
            '<a href="' + escAttr(item.url || '/') + '" class="wishlist-card__title-link">' + escText(item.title || '') + '</a>' +
          '</h3>' +
          '<span class="wishlist-card__price">' + priceStr + '</span>' +
          (dateStr ? '<span class="wishlist-card__added-date">' + escText(dateStr) + '</span>' : '') +
        '</div>';

      /* ── Image error handling ── */
      var imgElement = card.querySelector('.wishlist-card__image');
      if (imgElement) {
        imgElement.addEventListener('error', function () {
          /* First try: re-fetch from Shopify product API */
          if (!imgElement.dataset.retried) {
            imgElement.dataset.retried = 'true';
            tryRefreshImage(imgElement, item);
          } else {
            /* Second failure: replace with placeholder */
            var mediaEl = imgElement.closest('.wishlist-card__image-link');
            if (mediaEl) {
              mediaEl.innerHTML = createPlaceholderHTML();
            }
          }
        });

        /* Handle already-cached broken images */
        if (imgElement.complete && imgElement.naturalWidth === 0 && item.image) {
          imgElement.dispatchEvent(new Event('error'));
        }
      }

      /* Remove handler */
      var removeBtn = card.querySelector('[data-remove]');
      if (removeBtn) {
        removeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          TAAR.Wishlist.remove(item.id);
          card.classList.add('is-removing');
          setTimeout(function () {
            if (card.parentNode) card.parentNode.removeChild(card);
            var remaining = gridEl ? gridEl.querySelectorAll('[data-wishlist-card]').length : 0;
            if (remaining === 0) {
              if (gridEl) gridEl.setAttribute('hidden', '');
              showEmpty();
            } else {
              updateCountBadge(remaining);
            }
          }, 300);
        });
      }

      /* Add to bag handler */
      if (canQuickAdd) {
        var atbBtn = card.querySelector('[data-atb]');
        if (atbBtn) {
          atbBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (atbBtn.disabled || atbBtn.classList.contains('btn--loading')) return;
            atbBtn.classList.add('btn--loading');
            atbBtn.disabled = true;
            var prevText = atbBtn.textContent;
            atbBtn.textContent = '…';
            TAAR.Cart.addItem(parseInt(item.variantId, 10), 1)
              .then(function () {
                atbBtn.textContent = 'Added ✓';
                TAAR.Toast.show((item.title || 'Item') + ' added to bag');
                TAAR.EventBus.emit('cart:opened');
                setTimeout(function () {
                  atbBtn.textContent = prevText;
                  atbBtn.disabled = false;
                  atbBtn.classList.remove('btn--loading');
                }, 2200);
              })
              .catch(function () {
                atbBtn.textContent = prevText;
                atbBtn.disabled = false;
                atbBtn.classList.remove('btn--loading');
                window.location.href = item.url || '/';
              });
          });
        }
      }

      return card;
    }

    /* Clear all handler */
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        var items = TAAR.Wishlist.getAll();
        items.forEach(function (item) { TAAR.Wishlist.remove(item.id); });
        if (gridEl) gridEl.innerHTML = '';
        if (gridEl) gridEl.setAttribute('hidden', '');
        showEmpty();
      });
    }

    /* Hydrate */
    var items = TAAR.Wishlist.getAll();

    if (!items || items.length === 0) {
      showEmpty();
      return;
    }

    items.forEach(function (item, idx) {
      if (gridEl) gridEl.appendChild(renderCard(item, idx));
    });

    showGrid();

    /* Sync removals triggered elsewhere (e.g. product page wishlist toggle) */
    TAAR.EventBus.on('wishlist:removed', function (data) {
      var card = gridEl && gridEl.querySelector('[data-product-id="' + data.id + '"]');
      if (card && !card.classList.contains('is-removing')) {
        card.classList.add('is-removing');
        setTimeout(function () {
          if (card.parentNode) card.parentNode.removeChild(card);
          var remaining = gridEl ? gridEl.querySelectorAll('[data-wishlist-card]').length : 0;
          if (remaining === 0) {
            if (gridEl) gridEl.setAttribute('hidden', '');
            showEmpty();
          } else {
            updateCountBadge(remaining);
          }
        }, 300);
      }
    });

    /* Helpers */
    function escAttr(str) {
      return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function escText(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
  });
}());

  } catch(e) { console.error(e); }
})();
})();
